<template>
  <WelcomeBackBanner></WelcomeBackBanner>
  <HeaderSection></HeaderSection>
  <HeroSection></HeroSection>
  <div id="how-it-works" class="section-background section-padding">
    <HowItWorksSection></HowItWorksSection>
  </div>
  <FaqSection></FaqSection>
  <div id="join-the-club">
    <join-the-club-section></join-the-club-section>
  </div>
  <FooterSection></FooterSection>
</template>

<script setup lang="ts">
import FlowbiteService from '@/services/flowbite'
import { onMounted } from 'vue'
import FooterSection from '../../components/FooterSection.vue'
import FaqSection from './components/FaqSection.vue'
import HeaderSection from './components/HeaderSection.vue'
import HeroSection from './components/HeroSection.vue'
import HowItWorksSection from './components/HowItWorksSection.vue'

import JoinTheClubSection from './components/JoinTheClubSection.vue'
import WelcomeBackBanner from './components/WelcomeBackBanner.vue'

onMounted(() => {
  FlowbiteService.init()
})
</script>

<style scoped></style>
